<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row mb-2">
          <div class="col-md-9">
            <fieldset>
              <legend class="text-black">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.fromSchool'
                  )
                }}
              </legend>
              <div class="row">
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.fromSchool'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.changed_in_from_school"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('changed_in_from_school')
                        }"
                      />
                      <div
                        v-if="errors.has('changed_in_from_school')"
                        class="invalid-feedback"
                      >
                        {{ errors.first('changed_in_from_school') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.fromSchoolType'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <a-select
                        style="width: 100%"
                        allowClear
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.changed_in_from_school_type"
                        :options="itemListOptions"
                      ></a-select>
                      <div
                        v-if="errors.has('changed_in_from_school_type')"
                        class="validate"
                      >
                        {{ errors.first('changed_in_from_school_type') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.anotherProgram'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        type="text"
                        v-model.trim="model.current_school_another_program"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has(
                            'current_school_another_program'
                          )
                        }"
                      />
                      <small>
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.atAnotherSchool'
                          )
                        }}
                      </small>
                      <div
                        v-if="errors.has('current_school_another_program')"
                        class="invalid-feedback"
                      >
                        {{ errors.first('current_school_another_program') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.schoolType'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <a-select
                        style="width: 100%"
                        allowClear
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.current_school_another_program_type"
                        :options="itemListOptions"
                      ></a-select>
                      <div
                        v-if="errors.has('current_school_another_program_type')"
                        class="validate"
                      >
                        {{
                          errors.first('current_school_another_program_type')
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.studyTime'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <a-select
                        showSearch
                        style="width: 100%"
                        allowClear
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.ac_st_id"
                        :options="studyTimesOptions"
                      ></a-select>
                      <div v-if="errors.has('ac_st_id')" class="validate">
                        {{ errors.first('ac_st_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-8">
                      <ts-checkbox
                        v-model="model.is_appear_other_branch"
                        :value="1"
                        @change="onAppearOtherBranchChnage"
                      >
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.appearOtherBranch'
                          )
                        }}
                      </ts-checkbox>
                      <div
                        class="ts-w-full ts-p-3 ts-border ts-mt-3 ts-rounded ts-overflow-scroll"
                        v-if="model.is_appear_other_branch"
                        style="max-height: 150px;"
                      >
                        <ts-checkbox
                          v-for="(b, index) in branches"
                          v-model="model.appear_other_branch_id"
                          :key="index"
                          :value="b.branch_id"
                          >{{ b.branch_name_en }}</ts-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row" v-if="isCreateNew">
          <div class="col-md-9">
            <fieldset>
              <legend class="text-black">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.enrollment'
                  )
                }}
              </legend>
              <div class="row">
                <div class="col-md-12">
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.className'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <ts-select-class v-model.number="model.class_id" />
                      <div
                        v-if="errors.has('class_id')"
                        class="invalid-feedback"
                      >
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import TsSelectClass from '@/components/SelectClass'
import { isEmpty } from 'lodash'

export default {
  name: 'school-information-form',
  components: { TsSelectClass },
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      branches: [],
      loadingPreData: false,
      branches: [],
      errors: new Errors()
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
    this.model = this.value
  },
  computed: {
    ...mapState('studentProfile', ['itemLists', 'studyTimes', 'edit_data']),
    studyTimesOptions() {
      return this.studyTimes.map(el => ({
        value: el.ac_st_id,
        label: el.session + '|' + el.study_time
      }))
    },
    itemListOptions() {
      return this.itemLists.map(el => ({
        value: el.item_list_id,
        label: el.description
      }))
    },
    isCreateNew() {
      if (!isEmpty(this.edit_data)) {
        return this.edit_data.classes.length == 0
      }
      return true
    }
  },
  methods: {
    ...mapActions('studentProfile', ['fetchStudyTime']),
    ...mapActions('user', ['getBranch']),
    async fetchResourceBeforeCreate() {
      this.loadingPreData = true
      await Promise.all([this.fetchStudyTime()]).then(() => {})
      await this.$store
        .dispatch('studentProfile/dataForSchoolInformation')
        .then(() => {
          this.model = this.value
          this.setEditData()
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
      await this.getBranch().then(response => {
        this.branches = response.data
      })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.student_id = this.edit_data.student_id
        this.model.changed_in_from_school = this.edit_data.changed_in_from_school
        this.model.changed_in_from_school_type = this.edit_data.changed_in_from_school_type
        this.model.current_school_another_program = this.edit_data.current_school_another_program
        this.model.current_school_another_program_type = this.edit_data.current_school_another_program_type
        this.model.is_appear_other_branch = this.edit_data.is_appear_other_branch
        this.model.ac_st_id = this.edit_data.ac_st_id
        this.model.appear_other_branch_id = this.edit_data.appear_other_branch_id
      }
    },
    onAppearOtherBranchChnage(e) {
      if (!e) {
        this.model.appear_other_branch_id = []
      }
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function(value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
